import { render, staticRenderFns } from "./VideoChatBody.vue?vue&type=template&id=6e6788d5&scoped=true&"
import script from "./VideoChatBody.vue?vue&type=script&lang=js&"
export * from "./VideoChatBody.vue?vue&type=script&lang=js&"
import style0 from "./VideoChatBody.vue?vue&type=style&index=0&id=6e6788d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6788d5",
  null
  
)

export default component.exports